import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fetchBudgetV2, fetchBudgetVersionsV2 } from "../../../../api/fetchBudgetV2";

import { IBudgetVersionItem } from "../../../../models/budgetV2";

export const useBudgetVersionsDialog = (budgetId: string, show: boolean, persona: string, onClose: () => void, budgetRecipient?: string) => {
    const navigate = useNavigate();
    const [versions, setVersions] = useState<IBudgetVersionItem[]>([]);
    const [currentVersion, setCurrentVersion] = useState<IBudgetVersionItem | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      if (show && budgetId) {
        loadVersions();
      }
    }, [show, budgetId]);
  
    const loadVersions = async () => {
      setLoading(true);
      try {
        const response = await fetchBudgetVersionsV2(budgetId);
        setVersions(response);
        if (response.length > 0) {
          setCurrentVersion(response.sort((a, b) => (b?.versionNumber || 0) - (a?.versionNumber || 0))[0]);
        }
      } catch (error) {
        console.error("[useBudgetVersionsDialog] Erro ao carregar versões:", error);
      } finally {
        setLoading(false);
      }
    };
  
  
    const goToBudgetVersion = async (version: IBudgetVersionItem) => {
      if (!budgetId) return;
  
      try {
        const route = `${budgetId}/versions/${version.versionNumber}`;
        // the list item may be stale (e.g. decided after the kanban loaded): read the current recipient from the API
        const currentRecipient = await fetchBudgetV2(budgetId, version.versionNumber ?? 1)
          .then((current) => current?.recipient)
          .catch(() => undefined);
        const suffix = isLastVersion(version.versionNumber) && isNotFinished(version) && isRecipientUser(version, currentRecipient) ? "edit" : "details";

        navigate(`${route}/${suffix === "edit" && persona === 'fleet-manager' ? 'edit-manager' : suffix}`);
        onClose();
      } catch (error) {
        console.error("[BudgetHistoryModal] Erro ao redirecionar:", error);
      }
    };

    const isLastVersion = (version?: number | null) => version === versions.length;
    const isNotFinished = (version: IBudgetVersionItem) => version.status !== 'Aprovado pelo gestor' && !/recusad|rejeitad/i.test(version.status ?? '');
    // the version's own recipient is not updated by decisions; budget.recipient is the current one
    const isRecipientUser = (version: IBudgetVersionItem, currentRecipient?: string) => {
      const recipient = currentRecipient ?? budgetRecipient ?? version.recipient;
      switch (persona) {
        case 'fleet-manager':
          return recipient === "MANAGER";
        case 'dealership':
          return recipient === "CONSULTANT";
        case 'control-tower':
          return recipient === "FACTORY";
        default:
          return false;
      }
    }

    return {
        versions,
        currentVersion,
        loading,
        
        goToBudgetVersion,
    };
};